import { setFilter } from '../../../State/filters'

export default (field, value) => (dispatch) => {

  dispatch(setFilter({ field, value }))

}
